import React from 'react'
import { Redirect, Router } from '@reach/router'

import Layout from '@cinch/oxd-layouts/regular/src'
import { FEATURES, hasFeatureFlag } from '@cinch/oxd-utils/feature-flags/src'

// Stages
import Holding from './stages/holding/holding.component'
import LandingPage from './stages/landing-page/landing-page.component'
import ManualLookup from './stages/manual-lookup/manual-lookup.component'
import VehicleConfirm from './stages/vehicle-confirm/vehicle-confirm.component'
import VehicleQuestions from './stages/vehicle-questions/vehicle-questions.component'
import Valuation from './stages/valuation/valuation.component'
import ValuationUpdate from './stages/valuation-update/valuation-update.component'
import AppointmentVerify from './stages/appointment-verify/appointment-verify.component'
import AppointmentBooked from './stages/appointment-booked/appointment-booked.component'

import EnabledBy from './components/enabled-by'

import { Pages } from './types'

interface Props {
  i18n: Cinch.WebAppTranslations['sellVehicle']
  content: {
    disclaimer: React.ReactNode
    transaction: React.ReactNode
    guarantee: React.ReactNode
    paymentTerms: React.ReactNode
  }
}

const SellPage: React.FC<Props> = ({ i18n, content }) => {
  return (
    <Layout>
      {hasFeatureFlag(FEATURES.SELL_HOLD) ? (
        <Router>
          <Holding path="/sell/*" />
        </Router>
      ) : (
        <Router>
          <LandingPage path={Pages.Sell} i18n={i18n.landing} disclaimer={content.disclaimer} />
          <LandingPage
            path={Pages.SellCheckRegistration}
            i18n={i18n.landing}
            disclaimer={content.disclaimer}
            isRetry={true}
          />
          <ManualLookup path={Pages.SellManualLookup} i18n={i18n.manualLookup} />
          <VehicleConfirm path={Pages.SellCar} i18n={i18n.car} />
          <VehicleQuestions path={Pages.SellDetails} i18n={i18n.questions} />
          <Valuation
            path={Pages.SellValuationView}
            i18n={i18n.valuation}
            guarantee={content.guarantee}
            paymentTerms={content.paymentTerms}
            transaction={content.transaction}
          />
          <ValuationUpdate path={Pages.SellValuationUpdate} />
          <AppointmentVerify path={Pages.SellAppointmentVerify} />
          <AppointmentBooked path={Pages.SellAppointmentBooked} />

          <Redirect from="/sell/check-registration" to={Pages.Sell} noThrow={true} />
          <Redirect from="/sell/manual-lookup" to={Pages.Sell} noThrow={true} />
          <Redirect from="/sell/valuation" to={Pages.Sell} noThrow={true} />
          <Redirect from="/sell/appointment" to={Pages.Sell} noThrow={true} />
          <Redirect from="/sell/multicar" to={Pages.Sell} noThrow={true} />
        </Router>
      )}

      {!hasFeatureFlag(FEATURES.SELL_HOLD) && <EnabledBy />}
    </Layout>
  )
}

export default SellPage
